import React from 'react'

function WorkingProcessTwo() {
    return (
        <div>
            {/* our working Process */}
            <div className="working-process-area working-process-area2 rts-section-gap working-process-bg">
                <div className="container">
                    <div className="row mt--40">
                        <div className="title-area text-center working-process">
                            <span>Como Trabalhamos</span>
                            <h2 className="title">Nosso Fluxo em 3 Etapas</h2>
                        </div>
                    </div>

                    <div className="row g-5 mt--20 align-items-center">
                        {/* Passo 1 */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rts-working-process-1 text-center">
                                <div className="inner">
                                    <div className="icon">
                                        <img
                                            src="assets/images/home/12/1.png"
                                            alt="Working_process"
                                        />
                                    </div>
                                </div>
                                <div className="content">
                                    <h6 className="title">Diagnóstico Estratégico</h6>
                                    <p className="disc">
                                        Entendemos o momento do cliente, analisamos indicadores
                                        e mapeamos necessidades financeiras e estratégicas.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Passo 2 */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rts-working-process-1 process-lg text-center">
                                <div className="inner two">
                                    <div className="icon">
                                        <img
                                            src="assets/images/home/12/2.png"
                                            alt="Working_process"
                                        />
                                    </div>
                                </div>
                                <div className="content">
                                    <h6 className="title">Mapeamento das Oportunidades</h6>
                                    <p className="disc">
                                        Conectamos o cliente às melhores opções de crédito,
                                        seguros e soluções estratégicas disponíveis no mercado.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Passo 3 */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="rts-working-process-1 text-center">
                                <div className="inner three">
                                    <div className="icon">
                                        <img
                                            src="assets/images/home/12/3.png"
                                            alt="Working_process"
                                        />
                                    </div>
                                </div>
                                <div className="content">
                                    <h6 className="title">Operação Estruturada e Acompanhamento</h6>
                                    <p className="disc">
                                        Estruturamos a operação, acompanhamos cada etapa
                                        e garantimos segurança, clareza e transparência em todo o processo.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* our working Process End */}
        </div>
    )
}

export default WorkingProcessTwo
